import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, isRef as _isRef, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2d3d3601"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "kam-kam001" }
const _hoisted_2 = { class: "kam-top-head" }
const _hoisted_3 = { class: "kam-top-row head" }
const _hoisted_4 = { class: "kam-cell" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "kam-cell-title" }, [
  /*#__PURE__*/_createTextVNode("Uitvoerder "),
  /*#__PURE__*/_createElementVNode("span", { class: "req" }, "*")
], -1))
const _hoisted_6 = { class: "kam-cell" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "kam-cell-title" }, [
  /*#__PURE__*/_createTextVNode("Projectleider "),
  /*#__PURE__*/_createElementVNode("span", { class: "req" }, "*")
], -1))
const _hoisted_8 = { class: "kam-cell" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "kam-cell-title" }, [
  /*#__PURE__*/_createTextVNode("Datum van incident "),
  /*#__PURE__*/_createElementVNode("span", { class: "req" }, "*")
], -1))
const _hoisted_10 = { class: "kam-top-blocks" }
const _hoisted_11 = { class: "kam-top-row blocks" }
const _hoisted_12 = { class: "kam-cell block" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "kam-cell-title" }, [
  /*#__PURE__*/_createTextVNode("Betrokken partijen "),
  /*#__PURE__*/_createElementVNode("span", { class: "req" }, "*")
], -1))
const _hoisted_14 = { class: "kam-cell block" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "kam-cell-title" }, "Getuigen", -1))
const _hoisted_16 = { class: "kam-block" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "kam-block-title" }, "Incident details", -1))
const _hoisted_18 = { class: "grid-2" }
const _hoisted_19 = { class: "field" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createTextVNode("Wat is er gebeurd? "),
  /*#__PURE__*/_createElementVNode("span", { class: "req" }, "*")
], -1))
const _hoisted_21 = { class: "field" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createTextVNode("Waar is het gebeurd? "),
  /*#__PURE__*/_createElementVNode("span", { class: "req" }, "*")
], -1))
const _hoisted_23 = { class: "kam-block" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "kam-block-title" }, "Foto’s", -1))
const _hoisted_25 = { class: "grid-2" }
const _hoisted_26 = { class: "field" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createTextVNode("Overzichtsfoto('s) situatie "),
  /*#__PURE__*/_createElementVNode("span", { class: "req" }, "*")
], -1))
const _hoisted_28 = { class: "field" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Detailfoto('s) situatie", -1))
const _hoisted_30 = {
  class: "kam-top-letsel",
  style: {"margin-top":"12px"}
}
const _hoisted_31 = { class: "kam-top-row single" }
const _hoisted_32 = { class: "kam-cell block" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "kam-cell-title" }, "Is er letsel?", -1))
const _hoisted_34 = {
  key: 0,
  class: "kam-block inner",
  style: {"margin-top":"12px"}
}
const _hoisted_35 = { class: "grid-2" }
const _hoisted_36 = { class: "field" }
const _hoisted_37 = {
  key: 0,
  class: "req"
}
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "field-note" }, "Selecteer personen uit Woonon of voeg handmatig namen toe van personen die niet in Woonon staan.", -1))
const _hoisted_39 = { class: "field" }
const _hoisted_40 = {
  key: 0,
  class: "req"
}
const _hoisted_41 = {
  class: "kam-top-environment",
  style: {"margin-top":"12px"}
}
const _hoisted_42 = { class: "kam-top-row single" }
const _hoisted_43 = { class: "kam-cell block" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "kam-cell-title" }, "Is er een milieu-incident?", -1))
const _hoisted_45 = {
  key: 0,
  class: "kam-block inner",
  style: {"margin-top":"12px"}
}
const _hoisted_46 = { class: "grid-2" }
const _hoisted_47 = { class: "field" }
const _hoisted_48 = {
  key: 0,
  class: "req"
}
const _hoisted_49 = { class: "field" }
const _hoisted_50 = {
  key: 0,
  class: "req"
}
const _hoisted_51 = {
  class: "kam-top-material",
  style: {"margin-top":"12px"}
}
const _hoisted_52 = { class: "kam-top-row single" }
const _hoisted_53 = { class: "kam-cell block" }
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "kam-cell-title" }, "Is er materiaalschade?", -1))
const _hoisted_55 = {
  key: 0,
  class: "kam-block inner",
  style: {"margin-top":"12px"}
}
const _hoisted_56 = { class: "grid-2" }
const _hoisted_57 = { class: "field" }
const _hoisted_58 = {
  key: 0,
  class: "req"
}
const _hoisted_59 = { class: "field" }
const _hoisted_60 = {
  key: 0,
  class: "req"
}
const _hoisted_61 = {
  class: "kam-top-danger",
  style: {"margin-top":"12px"}
}
const _hoisted_62 = { class: "kam-top-row single" }
const _hoisted_63 = { class: "kam-cell block" }
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "kam-cell-title" }, "Was er een gevaarlijke situatie?", -1))
const _hoisted_65 = {
  key: 0,
  class: "kam-block inner",
  style: {"margin-top":"12px"}
}
const _hoisted_66 = { class: "danger-row" }
const _hoisted_67 = { class: "danger-col field" }
const _hoisted_68 = {
  key: 0,
  class: "req"
}
const _hoisted_69 = { class: "danger-col field" }
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Foto('s) gevaarlijke situatie", -1))
const _hoisted_71 = {
  key: 0,
  class: "kam-block kam-accident-result-block"
}
const _hoisted_72 = { class: "grid-2 kam-accident-result-grid" }
const _hoisted_73 = { class: "field" }
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createTextVNode("Gevolg van arbeidsongeval "),
  /*#__PURE__*/_createElementVNode("span", { class: "req" }, "*")
], -1))
const _hoisted_75 = {
  key: 0,
  class: "field"
}
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createTextVNode("Meldingsnummer NLA "),
  /*#__PURE__*/_createElementVNode("span", { class: "req" }, "*")
], -1))
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { style: {"display":"block","margin-top":"8px"} }, [
  /*#__PURE__*/_createTextVNode("Datum van melden bij NLA "),
  /*#__PURE__*/_createElementVNode("span", { class: "req" }, "*")
], -1))
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { style: {"display":"block","margin-top":"8px"} }, [
  /*#__PURE__*/_createTextVNode("Contactpersoon intern "),
  /*#__PURE__*/_createElementVNode("span", { class: "req" }, "*")
], -1))
const _hoisted_79 = { class: "kam-actions-bottom" }
const _hoisted_80 = { class: "kam-missing-list" }
const _hoisted_81 = { class: "kam-actions-bottom-inner" }

import { computed, ref, watch, nextTick } from 'vue'
import type { ComputedRef } from 'vue'
import { notification } from 'ant-design-vue'
import Uploader from '@/components/Uploader.vue'
import Filelist from '@/components/Filelist.vue'
import kamStore from '@/stores/kam.ts'
import { authStore } from '@/stores/auth'
import { KAMFormStatuses, KAMFormStatusLabelColors } from '@/helpers/kamFormStates'
import {
  createDatePickerProxy,
  detectPersonLabelField,
  ensureAnswersMedia,
  ensureNumberValue,
  hasAnyMeaningfulValue,
  hasMeaningfulValue,
  normalizeBooleanField,
  queuePendingUpload,
  removeTemporaryMedia,
  useConditionalRequiredFields,
  useDirtySnapshot
} from '@/helpers/kamFormUtils'

 type PersonOption = { id: number; full_name?: string; name?: string; phone?: string; email?: string }
 type MediaFile = { id: number; url?: string }
type Media = {
  overviewPhotos?: MediaFile[]
  detailPhotos?: MediaFile[]
  materialDamagePhotos?: MediaFile[]
  dangerousSituationPhotos?: MediaFile[]
  environmentalPhotos?: MediaFile[]
  reports?: MediaFile[] | MediaFile
}
type ProjectLike = {
  reference?: string
  name?: string
  city?: string
  project_leader?: { id?: string | number | null }
}

 type Answers = Record<string, any> & {
   siteManagerId?: number | null
   projectManagerId?: number | null

   woononInvolvedParties?: number[]
   nonWoononInvolved?: boolean
   nonWoononInvolvedParties?: string[]

   woononWitnesses?: number[]
   nonWoononWitnessesInvolved?: boolean
   nonWoononWitnesses?: string[]

   dateTimeOfIncident?: Date | string | null

   dangerousSituation?: boolean | null
   injuries?: boolean | null
   materialDamage?: boolean | null
   environmentalIncident?: boolean | null
   resultOfAccident?: number | null

   incidentDescription?: string
   incidentLocation?: string
   referenceNLA?: string | null
   notificationDateNLA?: Date | string | null
   kamManagerId?: number | null

   woononInjuredPeople?: number[]
   nonWoononInjured?: boolean
   nonWoononInjuredPeople?: string[]
   injuryDescription?: string

   materialDamageDescription?: string
   environmentalIncidentDescription?: string

   dangerousSituationDescription?: string
 }


export default /*#__PURE__*/_defineComponent({
  __name: 'KAM001-v2',
  props: {
    answers: null,
    editable: { type: Boolean },
    siteManagers: null,
    projectLeaders: null,
    constructionWorkers: null,
    employees: null,
    qualityManagement: null,
    media: null
  },
  emits: ["dirty", "required-filled", "addMedia", "deleteMedia"],
  setup(__props: any, { emit }: { emit: ({(e: 'dirty', value: boolean): void
   (e: 'required-filled', value: boolean): void
   (e: 'addMedia', key: string, file: File): void
   (e: 'deleteMedia', file: { id: number }): void
 }), expose: any, slots: any, attrs: any }) {

const props = __props as {
   answers: Answers
   editable: boolean
   siteManagers: PersonOption[]
   projectLeaders: PersonOption[]
   constructionWorkers: PersonOption[]
   employees?: PersonOption[]
   qualityManagement?: PersonOption[]
   media?: Media
 };





const formAnswers = computed<Answers>(() => kamStore().kamForm?.answers as unknown as Answers ?? props.answers ?? ({} as Answers))
const editable = computed(() => props.editable)
const defaultKamManagerId = 7041
const siteManagers = computed(() => props.siteManagers ?? [])
const projectLeaders = computed(() => props.projectLeaders ?? [])
const constructionWorkers = computed(() => props.constructionWorkers ?? [])
const qualityManagement = computed(() => props.qualityManagement ?? [])

const media = computed(() => {
  return (kamStore().kamForm && (kamStore().kamForm as any).answers?.media) ? (kamStore().kamForm as any).answers.media : (props.media ?? {})
})
const saving = ref(false)
const validationRevision = ref(0)

function refreshValidation (): void {
  nextTick().then(() => {
    validationRevision.value += 1
  })
}

function emitAddMedia (key: string, file: any) {
  if (!kamStore().kamForm) return

  if (file instanceof File) {
    queuePendingUpload(kamStore().kamForm as Record<string, unknown>, key, file)
    emit('dirty', true)
    return
  }

  if (file && typeof file === 'object' && 'url' in file && typeof file.url === 'string') {
    queuePendingUpload(kamStore().kamForm as Record<string, unknown>, key, {
      url: file.url,
      name: file.name,
      file_name: file.file_name
    })
    emit('dirty', true)
  }
}

async function emitDeleteMedia (file: { id: number | string }) : Promise<void> {
  if (!file || file.id == null) return

  if (!kamStore().kamForm) return

  if (typeof file.id === 'string' && file.id.startsWith('tmp-')) {
    if (removeTemporaryMedia(kamStore().kamForm as Record<string, unknown>, file.id)) {
      emit('dirty', true)
    }
    return
  }

  try {
    await kamStore().deleteMedia(kamStore().kamForm.id, file.id)
    emit('dirty', true)
    notification.success({ message: 'Foto verwijderd.', description: 'De foto is succesvol verwijderd.', duration: 5 })
  } catch {}
}

async function sendReport () {
  if (!kamStore().kamForm) return
  if (saving.value) return

  if (!hasKamManagerSelected.value) {
    notification.warning({
      message: 'KAM-manager ontbreekt',
      description: 'Selecteer eerst een KAM-manager voordat je het formulier verstuurt.',
      duration: 6
    })
    return
  }

  const missing = getMissingRequiredLabels()
  if (missing.length > 0) {
    notification.warning({
      message: 'Formulier nog niet compleet',
      description: `Vul eerst nog in: ${missing.join(', ')}.`,
      duration: 6
    })
    return
  }

  const form = kamStore().kamForm
  const managerId = form.answers.kamManagerId

  saving.value = true
  try {
    await kamStore().saveForm(form.id, form.answers as Record<string, unknown>, KAMFormStatuses.Concept)
    await kamStore().reportForm(form.id, managerId)
    notification.success({ message: 'Rapport verzonden', description: 'Het incidentenrapport is succesvol verzonden naar de KAM-manager.', duration: 5 })
  } catch {
  } finally {
    saving.value = false
  }
}

function filterUsers (input: string, record: { id: number; full_name?: string; name?: string }) {
  const hay = (record.full_name ?? record.name ?? '').toLowerCase()
  return hay.indexOf((input ?? '').toLowerCase()) >= 0
}

function hasKey (obj: any, key: string): boolean {
  if (!obj || typeof obj !== 'object') return false
  return Object.prototype.hasOwnProperty.call(obj, key)
}

function getBool (obj: any, key: string, fallback: boolean | null = null): boolean | null {
  if (!hasKey(obj, key)) return fallback
  const v = obj[key]
  if (v === true || v === false) return v
  return fallback
}

function getWorkerValue (id: string | number): string {
  return `worker:${String(id)}`
}

function parseWorkerValue (value: string): number | null {
  if (!value.startsWith('worker:')) return null
  const normalized = Number(value.slice(7))
  return Number.isNaN(normalized) ? null : normalized
}

const siteManagersFieldNames = computed(() => ({ label: detectPersonLabelField(siteManagers.value as PersonOption[]), value: 'id' }))
const projectLeadersFieldNames = computed(() => ({ label: detectPersonLabelField(projectLeaders.value as PersonOption[]), value: 'id' }))
const qualityManagementFieldNames = computed(() => ({ label: detectPersonLabelField(qualityManagement.value as PersonOption[]), value: 'id' }))
const workersFieldNames = computed(() => ({ label: detectPersonLabelField(constructionWorkers.value as PersonOption[]), value: 'id' }))
const injuredPeopleFieldNames = computed(() => ({ label: 'label', value: 'value' }))
const nonWoononInjuredOptions = computed(() => {
  const names = Array.isArray(formAnswers.value.nonWoononInvolvedParties) ? formAnswers.value.nonWoononInvolvedParties : []
  const uniqueNames = Array.from(new Set(names.map((name) => String(name ?? '').trim()).filter((name) => name.length > 0)))
  return uniqueNames.map((name) => ({ label: name, value: name }))
})
const injuredPeopleOptions = computed(() => {
  const workerLabelField = detectPersonLabelField(constructionWorkers.value as PersonOption[])
  const workerOptions = constructionWorkers.value
    .filter((person) => person != null && person.id != null)
    .map((person) => {
      const label = String(person[workerLabelField] ?? '').trim()
      return {
        label,
        value: getWorkerValue(person.id)
      }
    })
    .filter((person) => person.label.length > 0)

  return [...workerOptions, ...nonWoononInjuredOptions.value]
})
const injuredPeopleSelection = computed<Array<string>>({
  get () {
    const woononValues = Array.isArray(formAnswers.value.woononInjuredPeople)
      ? formAnswers.value.woononInjuredPeople.map((id) => getWorkerValue(id))
      : []
    const nonWoononValues = Array.isArray(formAnswers.value.nonWoononInjuredPeople)
      ? formAnswers.value.nonWoononInjuredPeople.map((name) => String(name ?? '').trim()).filter((name) => name.length > 0)
      : []

    return [...woononValues, ...nonWoononValues]
  },
  set (values: Array<string>) {
    const normalizedValues = Array.isArray(values)
      ? values.map((value) => String(value ?? '').trim()).filter((value) => value.length > 0)
      : []

    const woononIds = normalizedValues
      .map((value) => parseWorkerValue(value))
      .filter((value): value is number => value != null)
    const nonWoononValues = normalizedValues.filter((value) => parseWorkerValue(value) == null)

    formAnswers.value.woononInjuredPeople = Array.from(new Set(woononIds))
    formAnswers.value.nonWoononInjuredPeople = Array.from(new Set(nonWoononValues))
    formAnswers.value.nonWoononInjured = formAnswers.value.nonWoononInjuredPeople.length > 0
  }
})
const dateTimeOfIncidentProxy = createDatePickerProxy(formAnswers, 'dateTimeOfIncident', 'YYYY-MM-DD HH:mm:ss')
const notificationDateNLAProxy = createDatePickerProxy(formAnswers, 'notificationDateNLA', 'YYYY-MM-DD')
const { capture } = useDirtySnapshot(formAnswers as unknown as ComputedRef<Record<string, unknown>>, (value) => emit('dirty', value))
const isQualityManagement = computed(() => {
  const roleNames = authStore().user?.roleNames ?? []
  return roleNames.includes('quality_management') || roleNames.includes('developer')
})
const showAccidentResultQuestion = computed(() => isQualityManagement.value && formAnswers.value.injuries === true)
const resultsOfAccident = ref([
  { label: 'Dagopname', value: 1 },
  { label: 'Ziekenhuisopname', value: 2 },
  { label: 'Blijvend letsel', value: 3 },
  { label: 'Dodelijke afloop', value: 4 },
  { label: 'Nog te bepalen', value: 5 },
  { label: 'Geen van bovenstaande', value: 6 }
])

function resultOfAccidentChanged () : void {
  if ([5, 6].includes(formAnswers.value.resultOfAccident ?? -1)) {
    formAnswers.value.referenceNLA = null
    formAnswers.value.notificationDateNLA = null
    ensureKamManagerDefault(formAnswers.value)
  }
  refreshValidation()
}

function filterInjuredPeopleOptions (input: string, option?: { label?: string, value?: string | number }): boolean {
  const hay = String(option?.label ?? option?.value ?? '').toLowerCase()
  return hay.includes(String(input ?? '').toLowerCase())
}

function getMissingRequiredLabels (): string[] {
  const revision = validationRevision.value
  if (revision < 0) return []
  const answers = formAnswers.value ?? {}
  const mediaFiles = media.value ?? {}
  const inj = getBool(answers, 'injuries', false) === true
  const mat = getBool(answers, 'materialDamage', false) === true
  const env = getBool(answers, 'environmentalIncident', false) === true
  const missing: string[] = []

  if (!hasMeaningfulValue(answers, 'siteManagerId')) missing.push('Uitvoerder')
  if (!hasMeaningfulValue(answers, 'projectManagerId')) missing.push('Projectleider')
  if (!hasMeaningfulValue(answers, 'dateTimeOfIncident')) missing.push('Datum van incident')
  if (!hasMeaningfulValue(answers, 'incidentDescription')) missing.push('Wat is er gebeurd?')
  if (!hasMeaningfulValue(answers, 'incidentLocation')) missing.push('Waar is het gebeurd?')

  const involvedPartiesOk = getBool(answers, 'nonWoononInvolved', false) === true
    ? hasAnyMeaningfulValue(answers, ['woononInvolvedParties', 'nonWoononInvolvedParties'])
    : hasMeaningfulValue(answers, 'woononInvolvedParties')
  if (!involvedPartiesOk) missing.push('Betrokken partijen')

  if (inj) {
    const injuredPeopleOk = injuredPeopleSelection.value.length > 0

    if (!injuredPeopleOk) missing.push('Wie heeft er letsel?')
    if (!hasMeaningfulValue(answers, 'injuryDescription')) missing.push('Wat is het letsel?')
  }

  if (mat && !hasMeaningfulValue(answers, 'materialDamageDescription')) {
    missing.push('Omschrijving van materiaalschade')
  }

  if (env && !hasMeaningfulValue(answers, 'environmentalIncidentDescription')) {
    missing.push('Toelichting milieu-incident')
  }

  if (getBool(answers, 'dangerousSituation', false) === true && !hasMeaningfulValue(answers, 'dangerousSituationDescription')) {
    missing.push('Toelichting gevaarlijke situatie')
  }

  if (showAccidentResultQuestion.value) {
    if (!hasMeaningfulValue(answers, 'resultOfAccident')) {
      missing.push('Gevolg van arbeidsongeval')
    }

    if ([2, 3, 4].includes(answers.resultOfAccident ?? -1)) {
      if (!hasMeaningfulValue(answers, 'referenceNLA')) missing.push('Meldingsnummer NLA')
      if (!hasMeaningfulValue(answers, 'notificationDateNLA')) missing.push('Datum van melden bij NLA')
      if (!hasMeaningfulValue(answers, 'kamManagerId')) missing.push('Contactpersoon intern')
    }
  }

  if ((mediaFiles.overviewPhotos?.length ?? 0) === 0) missing.push("Overzichtsfoto('s) situatie")
  if (mat && (mediaFiles.materialDamagePhotos?.length ?? 0) === 0) missing.push("Foto('s) materiaalschade")
  if (env && (mediaFiles.environmentalPhotos?.length ?? 0) === 0) missing.push("Foto('s) milieu-incident")

  return missing
}

const missingRequiredLabels = computed(() => getMissingRequiredLabels())
const minRequiredComputed = computed(() => missingRequiredLabels.value.length === 0)
const hasKamManagerSelected = computed(() => hasMeaningfulValue(formAnswers.value, 'kamManagerId'))

const allRequiredFilled = useConditionalRequiredFields(() => minRequiredComputed.value, (value) => emit('required-filled', value))

function normalizeNumberArrayField (answers: Answers, key: keyof Answers): void {
  const value = answers[key]
  answers[key] = (Array.isArray(value)
    ? value
      .map((entry) => ensureNumberValue(entry))
      .filter((entry): entry is number => entry != null)
    : []) as Answers[keyof Answers]
}

function normalizeStringArrayField (answers: Answers, key: keyof Answers): void {
  const value = answers[key]
  answers[key] = (Array.isArray(value)
    ? value.map((entry) => String(entry ?? '').trim()).filter((entry) => entry.length > 0)
    : []) as Answers[keyof Answers]
}

function normalizeNumberField (answers: Answers, key: keyof Answers): void {
  answers[key] = ensureNumberValue(answers[key]) as Answers[keyof Answers]
}

function ensureKamManagerDefault (answers: Answers): void {
  const normalizedKamManagerId = ensureNumberValue(answers.kamManagerId)
  answers.kamManagerId = normalizedKamManagerId ?? defaultKamManagerId
}

function normalizeAnswers (answers: Answers, project?: ProjectLike | null): void {
  ensureAnswersMedia({ answers })

  normalizeNumberField(answers, 'siteManagerId')
  normalizeNumberField(answers, 'projectManagerId')

  const leaderId = project?.project_leader?.id
  if (answers.projectManagerId == null && leaderId != null) {
    answers.projectManagerId = ensureNumberValue(leaderId)
  }

  const boolKeys = [
    'dangerousSituation',
    'injuries',
    'materialDamage',
    'environmentalIncident',
    'nonWoononInvolved',
    'nonWoononWitnessesInvolved',
    'nonWoononInjured'
  ]
  for (const key of boolKeys) {
    normalizeBooleanField(answers as Record<string, unknown>, key, false)
  }

  normalizeNumberArrayField(answers, 'woononInvolvedParties')
  normalizeNumberArrayField(answers, 'woononWitnesses')
  normalizeNumberArrayField(answers, 'woononInjuredPeople')
  normalizeStringArrayField(answers, 'nonWoononInvolvedParties')
  normalizeStringArrayField(answers, 'nonWoononWitnesses')
  normalizeStringArrayField(answers, 'nonWoononInjuredPeople')

  answers.nonWoononInjured = answers.nonWoononInjured || (answers.nonWoononInjuredPeople?.length ?? 0) > 0
  ensureKamManagerDefault(answers)
}

watch(() => kamStore().kamForm, async (newForm) => {
  if (!newForm) return
  const project = newForm.project as ProjectLike | null | undefined

  const answersObj = newForm.answers as Answers
  normalizeAnswers(answersObj, project)

  if (project && typeof project === 'object') {
    if (!answersObj.projectReference && project.reference) answersObj.projectReference = project.reference
    if (!answersObj.projectName && project.name) answersObj.projectName = project.name
    if (!answersObj.projectCity && project.city) answersObj.projectCity = project.city
    if (!answersObj.projectLocation && project.city) answersObj.projectLocation = project.city
  }

  await nextTick()
  capture(newForm.answers ?? {})
}, { immediate: true })


return (_ctx: any,_cache: any) => {
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_date_picker = _resolveComponent("a-date-picker")!
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_a_switch = _resolveComponent("a-switch")!
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_alert = _resolveComponent("a-alert")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_popconfirm = _resolveComponent("a-popconfirm")!
  const _component_a_card = _resolveComponent("a-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_card, { title: "Incidenten rapport" }, {
      extra: _withCtx(() => [
        _createVNode(_component_a_tag, {
          color: _unref(KAMFormStatusLabelColors)[_unref(kamStore)().kamForm.status]
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(kamStore)().kamForm.status_label), 1)
          ]),
          _: 1
        }, 8, ["color"])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _hoisted_5,
              _createVNode(_component_a_select, {
                disabled: !_unref(editable),
                "filter-option": filterUsers,
                "field-names": _unref(siteManagersFieldNames),
                options: _unref(siteManagers),
                value: _unref(formAnswers).siteManagerId,
                "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_unref(formAnswers).siteManagerId) = $event)),
                onChange: refreshValidation,
                "show-search": ""
              }, null, 8, ["disabled", "field-names", "options", "value"])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              _createVNode(_component_a_select, {
                disabled: !_unref(editable),
                "filter-option": filterUsers,
                "field-names": _unref(projectLeadersFieldNames),
                options: _unref(projectLeaders),
                value: _unref(formAnswers).projectManagerId,
                "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_unref(formAnswers).projectManagerId) = $event)),
                onChange: refreshValidation,
                "show-search": ""
              }, null, 8, ["disabled", "field-names", "options", "value"])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _hoisted_9,
              _createVNode(_component_a_date_picker, {
                style: {"width":"100%"},
                "value-format": "YYYY-MM-DD HH:mm:ss",
                format: "DD-MM-YYYY HH:mm",
                "show-time": true,
                "minute-step": 5,
                disabled: !_unref(editable),
                value: _unref(dateTimeOfIncidentProxy),
                "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => (_isRef(dateTimeOfIncidentProxy) ? (dateTimeOfIncidentProxy).value = $event : null)),
                onChange: refreshValidation
              }, null, 8, ["disabled", "value"])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _hoisted_13,
              _createVNode(_component_a_select, {
                mode: "multiple",
                disabled: !_unref(editable),
                "filter-option": filterUsers,
                "field-names": _unref(workersFieldNames),
                options: _unref(constructionWorkers),
                value: _unref(formAnswers).woononInvolvedParties,
                "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_unref(formAnswers).woononInvolvedParties) = $event)),
                onChange: refreshValidation,
                "show-search": ""
              }, null, 8, ["disabled", "field-names", "options", "value"]),
              _createVNode(_component_a_checkbox, {
                class: "mt8",
                disabled: !_unref(editable),
                checked: _unref(formAnswers).nonWoononInvolved,
                "onUpdate:checked": _cache[4] || (_cache[4] = ($event: any) => ((_unref(formAnswers).nonWoononInvolved) = $event)),
                onChange: refreshValidation
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Één van de betrokken partijen is niet bekend in Woonon ")
                ]),
                _: 1
              }, 8, ["disabled", "checked"]),
              (_unref(formAnswers).nonWoononInvolved)
                ? (_openBlock(), _createBlock(_component_a_select, {
                    key: 0,
                    class: "mt8",
                    mode: "tags",
                    disabled: !_unref(editable),
                    value: _unref(formAnswers).nonWoononInvolvedParties,
                    "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_unref(formAnswers).nonWoononInvolvedParties) = $event)),
                    onChange: refreshValidation
                  }, null, 8, ["disabled", "value"]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_14, [
              _hoisted_15,
              _createVNode(_component_a_select, {
                mode: "multiple",
                disabled: !_unref(editable),
                "filter-option": filterUsers,
                "field-names": _unref(workersFieldNames),
                options: _unref(constructionWorkers),
                value: _unref(formAnswers).woononWitnesses,
                "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_unref(formAnswers).woononWitnesses) = $event)),
                "show-search": ""
              }, null, 8, ["disabled", "field-names", "options", "value"]),
              _createVNode(_component_a_checkbox, {
                class: "mt8",
                disabled: !_unref(editable),
                checked: _unref(formAnswers).nonWoononWitnessesInvolved,
                "onUpdate:checked": _cache[7] || (_cache[7] = ($event: any) => ((_unref(formAnswers).nonWoononWitnessesInvolved) = $event))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Één van de getuigen is niet bekend in Woonon ")
                ]),
                _: 1
              }, 8, ["disabled", "checked"]),
              (_unref(formAnswers).nonWoononWitnessesInvolved)
                ? (_openBlock(), _createBlock(_component_a_select, {
                    key: 0,
                    class: "mt8",
                    mode: "tags",
                    disabled: !_unref(editable),
                    value: _unref(formAnswers).nonWoononWitnesses,
                    "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_unref(formAnswers).nonWoononWitnesses) = $event))
                  }, null, 8, ["disabled", "value"]))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_16, [
          _hoisted_17,
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("div", _hoisted_19, [
              _hoisted_20,
              _createVNode(_component_a_textarea, {
                disabled: !_unref(editable),
                value: _unref(formAnswers).incidentDescription,
                "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((_unref(formAnswers).incidentDescription) = $event)),
                "auto-size": { minRows: 3, maxRows: 8 },
                onInput: refreshValidation,
                onChange: refreshValidation
              }, null, 8, ["disabled", "value"])
            ]),
            _createElementVNode("div", _hoisted_21, [
              _hoisted_22,
              _createVNode(_component_a_textarea, {
                disabled: !_unref(editable),
                value: _unref(formAnswers).incidentLocation,
                "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((_unref(formAnswers).incidentLocation) = $event)),
                "auto-size": { minRows: 3, maxRows: 8 },
                onInput: refreshValidation,
                onChange: refreshValidation
              }, null, 8, ["disabled", "value"])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_23, [
          _hoisted_24,
          _createElementVNode("div", _hoisted_25, [
            _createElementVNode("div", _hoisted_26, [
              _hoisted_27,
              (_unref(editable))
                ? (_openBlock(), _createBlock(Uploader, {
                    key: 0,
                    "current-count": (_unref(media)?.overviewPhotos?.length ?? 0),
                    onNewFileUploaded: _cache[11] || (_cache[11] = (f) => emitAddMedia('overviewPhotos', f))
                  }, null, 8, ["current-count"]))
                : _createCommentVNode("", true),
              ((_unref(media)?.overviewPhotos?.length ?? 0) > 0)
                ? (_openBlock(), _createBlock(Filelist, {
                    key: 1,
                    media: _unref(media)?.overviewPhotos,
                    "can-delete": _unref(editable),
                    onDeleteFile: emitDeleteMedia
                  }, null, 8, ["media", "can-delete"]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_28, [
              _hoisted_29,
              (_unref(editable))
                ? (_openBlock(), _createBlock(Uploader, {
                    key: 0,
                    "current-count": (_unref(media)?.detailPhotos?.length ?? 0),
                    onNewFileUploaded: _cache[12] || (_cache[12] = (f) => emitAddMedia('detailPhotos', f))
                  }, null, 8, ["current-count"]))
                : _createCommentVNode("", true),
              ((_unref(media)?.detailPhotos?.length ?? 0) > 0)
                ? (_openBlock(), _createBlock(Filelist, {
                    key: 1,
                    media: _unref(media)?.detailPhotos,
                    "can-delete": _unref(editable),
                    onDeleteFile: emitDeleteMedia
                  }, null, 8, ["media", "can-delete"]))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_30, [
          _createElementVNode("div", _hoisted_31, [
            _createElementVNode("div", _hoisted_32, [
              _hoisted_33,
              _createVNode(_component_a_switch, {
                disabled: !_unref(editable),
                checked: _unref(formAnswers).injuries,
                "onUpdate:checked": _cache[13] || (_cache[13] = ($event: any) => ((_unref(formAnswers).injuries) = $event)),
                "checked-children": 'Ja',
                "un-checked-children": 'Nee',
                onChange: refreshValidation
              }, null, 8, ["disabled", "checked"]),
              (_unref(formAnswers).injuries)
                ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                    _createElementVNode("div", _hoisted_35, [
                      _createElementVNode("div", _hoisted_36, [
                        _createElementVNode("label", null, [
                          _createTextVNode("Wie heeft er letsel? "),
                          (_unref(formAnswers).injuries)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_37, "*"))
                            : _createCommentVNode("", true)
                        ]),
                        _createVNode(_component_a_select, {
                          mode: "tags",
                          disabled: !_unref(editable),
                          "filter-option": filterInjuredPeopleOptions,
                          "field-names": _unref(injuredPeopleFieldNames),
                          options: _unref(injuredPeopleOptions),
                          value: _unref(injuredPeopleSelection),
                          "onUpdate:value": _cache[14] || (_cache[14] = ($event: any) => (_isRef(injuredPeopleSelection) ? (injuredPeopleSelection).value = $event : null)),
                          onChange: refreshValidation,
                          "show-search": ""
                        }, null, 8, ["disabled", "field-names", "options", "value"]),
                        _hoisted_38
                      ]),
                      _createElementVNode("div", _hoisted_39, [
                        _createElementVNode("label", null, [
                          _createTextVNode("Wat is het letsel? "),
                          (_unref(formAnswers).injuries)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_40, "*"))
                            : _createCommentVNode("", true)
                        ]),
                        _createVNode(_component_a_textarea, {
                          disabled: !_unref(editable),
                          value: _unref(formAnswers).injuryDescription,
                          "onUpdate:value": _cache[15] || (_cache[15] = ($event: any) => ((_unref(formAnswers).injuryDescription) = $event)),
                          "auto-size": { minRows: 4, maxRows: 8 },
                          onInput: refreshValidation,
                          onChange: refreshValidation
                        }, null, 8, ["disabled", "value"])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_41, [
          _createElementVNode("div", _hoisted_42, [
            _createElementVNode("div", _hoisted_43, [
              _hoisted_44,
              _createVNode(_component_a_switch, {
                disabled: !_unref(editable),
                checked: _unref(formAnswers).environmentalIncident,
                "onUpdate:checked": _cache[16] || (_cache[16] = ($event: any) => ((_unref(formAnswers).environmentalIncident) = $event)),
                "checked-children": 'Ja',
                "un-checked-children": 'Nee',
                onChange: refreshValidation
              }, null, 8, ["disabled", "checked"]),
              (_unref(formAnswers).environmentalIncident)
                ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                    _createElementVNode("div", _hoisted_46, [
                      _createElementVNode("div", _hoisted_47, [
                        _createElementVNode("label", null, [
                          _createTextVNode("Toelichting milieu-incident "),
                          (_unref(formAnswers).environmentalIncident)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_48, "*"))
                            : _createCommentVNode("", true)
                        ]),
                        _createVNode(_component_a_textarea, {
                          disabled: !_unref(editable),
                          value: _unref(formAnswers).environmentalIncidentDescription,
                          "onUpdate:value": _cache[17] || (_cache[17] = ($event: any) => ((_unref(formAnswers).environmentalIncidentDescription) = $event)),
                          "auto-size": { minRows: 3, maxRows: 8 },
                          onInput: refreshValidation,
                          onChange: refreshValidation
                        }, null, 8, ["disabled", "value"])
                      ]),
                      _createElementVNode("div", _hoisted_49, [
                        _createElementVNode("label", null, [
                          _createTextVNode("Foto('s) milieu-incident "),
                          (_unref(formAnswers).environmentalIncident)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_50, "*"))
                            : _createCommentVNode("", true)
                        ]),
                        (_unref(editable))
                          ? (_openBlock(), _createBlock(Uploader, {
                              key: 0,
                              "current-count": (_unref(media)?.environmentalPhotos?.length ?? 0),
                              onNewFileUploaded: _cache[18] || (_cache[18] = (f) => emitAddMedia('environmentalPhotos', f))
                            }, null, 8, ["current-count"]))
                          : _createCommentVNode("", true),
                        ((_unref(media)?.environmentalPhotos?.length ?? 0) > 0)
                          ? (_openBlock(), _createBlock(Filelist, {
                              key: 1,
                              media: _unref(media)?.environmentalPhotos,
                              "can-delete": _unref(editable),
                              onDeleteFile: emitDeleteMedia
                            }, null, 8, ["media", "can-delete"]))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_51, [
          _createElementVNode("div", _hoisted_52, [
            _createElementVNode("div", _hoisted_53, [
              _hoisted_54,
              _createVNode(_component_a_switch, {
                disabled: !_unref(editable),
                checked: _unref(formAnswers).materialDamage,
                "onUpdate:checked": _cache[19] || (_cache[19] = ($event: any) => ((_unref(formAnswers).materialDamage) = $event)),
                "checked-children": 'Ja',
                "un-checked-children": 'Nee',
                onChange: refreshValidation
              }, null, 8, ["disabled", "checked"]),
              (_unref(formAnswers).materialDamage)
                ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
                    _createElementVNode("div", _hoisted_56, [
                      _createElementVNode("div", _hoisted_57, [
                        _createElementVNode("label", null, [
                          _createTextVNode("Omschrijving van materiaalschade "),
                          (_unref(formAnswers).materialDamage)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_58, "*"))
                            : _createCommentVNode("", true)
                        ]),
                        _createVNode(_component_a_textarea, {
                          disabled: !_unref(editable),
                          value: _unref(formAnswers).materialDamageDescription,
                          "onUpdate:value": _cache[20] || (_cache[20] = ($event: any) => ((_unref(formAnswers).materialDamageDescription) = $event)),
                          "auto-size": { minRows: 3, maxRows: 8 },
                          onInput: refreshValidation,
                          onChange: refreshValidation
                        }, null, 8, ["disabled", "value"])
                      ]),
                      _createElementVNode("div", _hoisted_59, [
                        _createElementVNode("label", null, [
                          _createTextVNode("Foto('s) materiaalschade "),
                          (_unref(formAnswers).materialDamage)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_60, "*"))
                            : _createCommentVNode("", true)
                        ]),
                        (_unref(editable))
                          ? (_openBlock(), _createBlock(Uploader, {
                              key: 0,
                              "current-count": (_unref(media)?.materialDamagePhotos?.length ?? 0),
                              onNewFileUploaded: _cache[21] || (_cache[21] = (f) => emitAddMedia('materialDamagePhotos', f))
                            }, null, 8, ["current-count"]))
                          : _createCommentVNode("", true),
                        ((_unref(media)?.materialDamagePhotos?.length ?? 0) > 0)
                          ? (_openBlock(), _createBlock(Filelist, {
                              key: 1,
                              media: _unref(media)?.materialDamagePhotos,
                              "can-delete": _unref(editable),
                              onDeleteFile: emitDeleteMedia
                            }, null, 8, ["media", "can-delete"]))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_61, [
          _createElementVNode("div", _hoisted_62, [
            _createElementVNode("div", _hoisted_63, [
              _hoisted_64,
              _createVNode(_component_a_switch, {
                disabled: !_unref(editable),
                checked: _unref(formAnswers).dangerousSituation,
                "onUpdate:checked": _cache[22] || (_cache[22] = ($event: any) => ((_unref(formAnswers).dangerousSituation) = $event)),
                "checked-children": 'Ja',
                "un-checked-children": 'Nee',
                onChange: refreshValidation
              }, null, 8, ["disabled", "checked"]),
              (_unref(formAnswers).dangerousSituation)
                ? (_openBlock(), _createElementBlock("div", _hoisted_65, [
                    _createElementVNode("div", _hoisted_66, [
                      _createElementVNode("div", _hoisted_67, [
                        _createElementVNode("label", null, [
                          _createTextVNode("Toelichting gevaarlijke situatie "),
                          (_unref(formAnswers).dangerousSituation)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_68, "*"))
                            : _createCommentVNode("", true)
                        ]),
                        _createVNode(_component_a_textarea, {
                          disabled: !_unref(editable),
                          value: _unref(formAnswers).dangerousSituationDescription,
                          "onUpdate:value": _cache[23] || (_cache[23] = ($event: any) => ((_unref(formAnswers).dangerousSituationDescription) = $event)),
                          "auto-size": { minRows: 3, maxRows: 8 },
                          onInput: refreshValidation,
                          onChange: refreshValidation
                        }, null, 8, ["disabled", "value"])
                      ]),
                      _createElementVNode("div", _hoisted_69, [
                        _hoisted_70,
                        (_unref(editable))
                          ? (_openBlock(), _createBlock(Uploader, {
                              key: 0,
                              "current-count": (_unref(media)?.dangerousSituationPhotos?.length ?? 0),
                              onNewFileUploaded: _cache[24] || (_cache[24] = (f) => emitAddMedia('dangerousSituationPhotos', f))
                            }, null, 8, ["current-count"]))
                          : _createCommentVNode("", true),
                        ((_unref(media)?.dangerousSituationPhotos?.length ?? 0) > 0)
                          ? (_openBlock(), _createBlock(Filelist, {
                              key: 1,
                              media: _unref(media)?.dangerousSituationPhotos,
                              "can-delete": _unref(editable),
                              onDeleteFile: emitDeleteMedia
                            }, null, 8, ["media", "can-delete"]))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        (_unref(showAccidentResultQuestion))
          ? (_openBlock(), _createElementBlock("div", _hoisted_71, [
              _createElementVNode("div", _hoisted_72, [
                _createElementVNode("div", _hoisted_73, [
                  _hoisted_74,
                  _createVNode(_component_a_radio_group, {
                    class: "vertical-radio-group",
                    options: resultsOfAccident.value,
                    disabled: !_unref(editable),
                    value: _unref(formAnswers).resultOfAccident,
                    "onUpdate:value": _cache[25] || (_cache[25] = ($event: any) => ((_unref(formAnswers).resultOfAccident) = $event)),
                    onChange: resultOfAccidentChanged
                  }, null, 8, ["options", "disabled", "value"])
                ]),
                ([2, 3, 4].includes(_unref(formAnswers).resultOfAccident ?? -1))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_75, [
                      _hoisted_76,
                      _createVNode(_component_a_input, {
                        type: "text",
                        disabled: !_unref(editable) || saving.value,
                        value: _unref(formAnswers).referenceNLA,
                        "onUpdate:value": _cache[26] || (_cache[26] = ($event: any) => ((_unref(formAnswers).referenceNLA) = $event)),
                        onInput: refreshValidation,
                        onChange: refreshValidation
                      }, null, 8, ["disabled", "value"]),
                      _hoisted_77,
                      _createVNode(_component_a_date_picker, {
                        "value-format": "YYYY-MM-DD",
                        format: "DD-MM-YYYY",
                        disabled: !_unref(editable) || saving.value,
                        value: _unref(notificationDateNLAProxy),
                        "onUpdate:value": _cache[27] || (_cache[27] = ($event: any) => (_isRef(notificationDateNLAProxy) ? (notificationDateNLAProxy).value = $event : null)),
                        onChange: refreshValidation
                      }, null, 8, ["disabled", "value"]),
                      _hoisted_78,
                      _createVNode(_component_a_select, {
                        "filter-option": filterUsers,
                        "field-names": _unref(qualityManagementFieldNames),
                        options: _unref(qualityManagement),
                        disabled: !_unref(editable) || saving.value,
                        value: _unref(formAnswers).kamManagerId,
                        "onUpdate:value": _cache[28] || (_cache[28] = ($event: any) => ((_unref(formAnswers).kamManagerId) = $event)),
                        onChange: refreshValidation,
                        "show-search": ""
                      }, null, 8, ["field-names", "options", "disabled", "value"])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]))
          : _createCommentVNode("", true),
        (_unref(isQualityManagement))
          ? (_openBlock(), _createBlock(_component_a_alert, {
              key: 1,
              class: "kam-accident-result-warning",
              message: "Let op!",
              description: "Vergeet dit incident niet te melden bij CI en de Arbeidsinspectie!",
              type: "warning",
              "show-icon": ""
            }))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_79, [
          (_unref(editable) && _unref(missingRequiredLabels).length > 0)
            ? (_openBlock(), _createBlock(_component_a_alert, {
                key: 0,
                class: "kam-actions-alert",
                type: "info",
                "show-icon": "",
                message: "Nog in te vullen voordat je kunt versturen"
              }, {
                description: _withCtx(() => [
                  _createElementVNode("ul", _hoisted_80, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(missingRequiredLabels), (label) => {
                      return (_openBlock(), _createElementBlock("li", { key: label }, _toDisplayString(label), 1))
                    }), 128))
                  ])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_81, [
            _createVNode(_component_a_select, {
              value: _unref(formAnswers).kamManagerId,
              "onUpdate:value": _cache[29] || (_cache[29] = ($event: any) => ((_unref(formAnswers).kamManagerId) = $event)),
              options: _unref(qualityManagement),
              "field-names": _unref(qualityManagementFieldNames),
              disabled: !_unref(editable) || saving.value,
              "filter-option": filterUsers,
              onChange: refreshValidation,
              "show-search": "",
              placeholder: "KAM-manager",
              class: "kam-manager-select",
              allowClear: ""
            }, null, 8, ["value", "options", "field-names", "disabled"]),
            _createVNode(_component_a_popconfirm, {
              placement: "bottomRight",
              "ok-text": "Ja, versturen",
              onConfirm: sendReport
            }, {
              default: _withCtx(() => [
                (_unref(editable) && _unref(kamStore)().kamForm && _unref(kamStore)().kamForm.status === _unref(KAMFormStatuses).Concept)
                  ? (_openBlock(), _createBlock(_component_a_button, {
                      key: 0,
                      type: "primary",
                      disabled: !_unref(allRequiredFilled) || !_unref(hasKamManagerSelected) || saving.value
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Versturen naar KAM-manager")
                      ]),
                      _: 1
                    }, 8, ["disabled"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _: 1
    })
  ]))
}
}

})